import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import Overlay from '../../Components/Overlay';
import MInput from '../../Components/Core/MInput';
import { trash } from '../../Images';
import MTextarea from '../../Components/Core/MTextArea';
import { handlerFormError, uuid } from '../../Utils/Utils';
import Swal from 'sweetalert2';
import { cancelPayment, createPayment, getPaymentById } from '../../Service/Payment';
import { NumberFormat } from '../../Components/NumberFormat';


let processingId = -1;
const PaymentForm = () => {
    const location = useLocation();
    const { pageState, id_payment } = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({
        processing: false,
        docnum: '',
        status_payment: '',
        u_m_bank_amt: location.state ? location.state.u_m_bank_amt : 0,
        u_m_doc_date: location.state ? location.state.u_m_doc_date : moment().format('DD MMMM YYYY'),
        listPayment: location.state ?  location.state.line_items : []
    })

    const { listPayment, u_m_doc_date, u_m_bank_amt, docnum, status_payment } = state;

    useEffect(_ => {
        switch (pageState) {
            case 'view':
                getPaymentById(id_payment).then(res => {
                    let result = res.data;
                    const _items = result.line_items.map(e => ({
                        id: e.id,
                        remarks: e.u_m_remark,
                        amount: e.u_m_amt
                    }));

                    setState({...state,
                        docnum : result.docnum,
                        status_payment: result.status,
                        u_m_bank_amt : result.u_m_bank_amt,
                        u_m_doc_date : result.u_m_doc_date,
                        listPayment : _items
                    })
                })

            break;
        }
    },[])

    const addPayment = () => {
        listPayment.push({
            remarks : '',
            amount : 0,
            id: uuid()
        });
        setState({ ...state, listPayment });
    }

    const onChangeNominal = (e, i) => {
        const index = listPayment.findIndex(item => item.id == i);
        if(index > -1) {
            listPayment[index].amount = e.target.value < 1 ? 1 : e.target.value;

            const total = Calculate(listPayment);
            setState({ ...state, listPayment , u_m_bank_amt: total.total});
        }
    }

    const Calculate = (list) => {
        let total = 0;
        for(const key in list){
            total += parseFloat(list[key].amount);
        }
        return {total};
    }

    const onRemovePayment = (row) => {
        let hpusArray = listPayment.filter(item => item.id !== row.id);
        const total = Calculate(hpusArray);
        setState({ ...state, listPayment: hpusArray, u_m_bank_amt: total.total})
    }

    const onChangeRemark = (e, i) => {
        const index = listPayment.findIndex(item => item.id == i);
        if(index > -1) {
            listPayment[index].remarks = e.target.value;
            setState({ ...state, listPayment });
        }
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const onCancel = () => {

        Swal.fire({
            icon: 'question',
            title: 'Are you sure',
            text: 'Canceled Payment can not be restored!',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                setState({ processing: true });
                cancelPayment(id_payment, res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Cancel payment success!'
                    }).then(res => {
                        navigate('/operationalcost');
                    });
                }, ({ response }) => {
                    const { message } = response?.data;
                    Swal.fire({
                        icon: 'error',
                        title: 'Cancel payment Error',
                        text: message
                    });
                }).finally(() => {
                    setState({ processing: false })
                });
            }
        });;


    }

    const onGoback = () => {
        navigate(-1);
    }

    const onSubmit = () => {
        let message = "";
        const amount_limit = 10 ** 10;
        for(const key in listPayment){
            if(listPayment[key].remarks == ""){
                message += "Remark required! \n";
            }else if(listPayment[key].amount == 0){
                message += "Amount must be greater than 0! \n";
            }else if(listPayment[key].amount >= amount_limit){
                message += "Amount is too large! \n";
            }
        }
        if (message != ""){
            Swal.fire({
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                title: "Please correct form",
                text: message
            });
            return;
        }

        let payload = {
            u_m_bank_amt : state.u_m_bank_amt,
            u_m_doc_date: state.u_m_doc_date,
            line_items :  listPayment.map(e => ({
                remarks: e.remarks,
                amount: e.amount
            }))
        }

        startProcessing();
        const response = createPayment(payload);
        response.then(res => {
        if (res.status == 200 || res.status == 201) {
            Swal.fire({
            icon: 'success',
            title: 'Save data success',
            text: 'Data has been saved!'
            }).then(r => { 
                navigate('/operationalcost');
            })
        }
        }).catch(({ response: { data } }) => {
            handlerFormError(data)
        }).finally(_ => stopProcessing());
    }

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-12">
                            <h2 className="title-breadcrum">
                                {pageState == 'create' ? 'Create Operational Cost' : 'Operational Cost #'} {docnum} &nbsp;
                                { state.status_payment == 'CANCELED' ?  
                                    <span className="badge bg-red me-2">CANCELED</span>
                                : state.status_payment == 'PAID' ?
                                    <span className="badge bg-paid me-2">PAID</span>
                                : state.status_payment == 'CLOSE' ?
                                    <span className="badge bg-close me-2">CLOSE</span>
                                : state.status_payment == 'OPEN' ?
                                    <span className="badge bg-cyan me-2">OPEN</span> : ''
                                }
                                
                            </h2>
                            <p>Date {u_m_doc_date}</p>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 bg-white">
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <h6 className="m-0 title-breadcrum tx-gray" >Detail Payment</h6>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Overlay display={state.processing} />
                            
                            <div className="table-responsive">
                                <table className="table table-hover" width="100%" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th className='th-no-border'>No</th>
                                            <th className='th-no-border'>Remark</th>
                                            <th className='th-no-border'>Currency</th>
                                            <th className='th-no-border'>Amount</th>
                                        </tr>
                                    </thead>

                                    { listPayment && listPayment.length > 0 &&
                                    <tbody>
                                        
                                        { listPayment.map((row, index) => (
                                            <tr key={`tr-` + index} >
                                                <td>{index + 1}</td>
                                                <td>
                                                    <MTextarea 
                                                        rows={3}
                                                        value={row.remarks} 
                                                        onChange={(e)=>onChangeRemark(e,row.id)}
                                                    />
                                                </td>
                                                <td>IDR</td>
                                                <td>
                                                    <MInput
                                                        label='Nominal'
                                                        type='number'
                                                        value={row.amount}
                                                        min={1}
                                                        onChange={(e)=>onChangeNominal(e,row.id)}
                                                    />
                                                </td>
                                                <td>
                                                    { docnum == "" && 
                                                        <div style={{border: 2, cursor: 'pointer'}} onClick={() => onRemovePayment(row)}>
                                                            <img src={trash} />
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                        { docnum == "" && 
                        <>
                            <div className='row d-flex align-items-center justify-content-center' style={{ marginBottom: 30 }}>
                                <button onClick={addPayment} className="btn btn-outline-primary" style={{ border: 'none', width: 200 }} type="button">
                                    <span className='fas fa-plus'></span> Add Payment
                                </button>
                            </div>
                            
                        </>
                        }
                        <div className='row' style={{ marginBottom: 30 , alignSelf: 'end', marginRight: 60}}>
                            <div><b>Grand Total</b>  {NumberFormat(u_m_bank_amt)}</div>
                        </div>
                    </div>
                    <div className='row' style={{ justifyContent: 'flex-end' }}>
                        { docnum == "" ? 
                            <>
                                <div className='col-sm-2'>
                                    <Link to="/sales" className='btn btn-readonly btn-block' style={{ marginBottom: 30 }}>Cancel</Link>
                                </div>
                                <div className='col-sm-2'>
                                    <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={onSubmit} >
                                        Submit
                                    </button>
                                </div>
                            </>
                            
                            :
                            <>
                                <div className='col-sm-2'>
                                    <button type='button' className='btn btn-outline-dark' style={{ width: 150, marginRight: 20 }} onClick={onGoback}><i className='fa fa-reply' /> Back</button>
                                </div>
                                <div className='col-sm-2'>
                                    <button disabled={status_payment !== 'OPEN'} className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={onCancel} >
                                        <i className='fa fa-times' /> Cancel
                                    </button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PaymentForm;
